
export let commonData = {
  invoiceServideOptions : [
    {
      value: '生产生活服务', label: '生产生活服务', children: [
        { value: '技术服务费', label: '技术服务费' },
        { value: '广告费', label: '广告费' },
        { value: '信息服务费', label: '信息服务费' },
        { value: '服务费', label: '服务费' },
        { value: '广告发布费', label: '广告发布费' },
        { value: '信息技术服务费', label: '信息技术服务费' },
        { value: '视频制作费', label: '视频制作费' },
        { value: '软件开发服务费', label: '软件开发服务费' },
        { value: '咨询服务费', label: '咨询服务费' },
        { value: '推广费', label: '推广费' },
        { value: '现代服务费', label: '现代服务费' },
        { value: '推广服务费', label: '推广服务费' },
        { value: '创意策划服务费', label: '创意策划服务费' },
      ]
    },
    {
      value: '信息技术服务', label: '信息技术服务', children: [
        { value: '技术服务费', label: '技术服务费' },
        { value: '广告费', label: '广告费' },
        { value: '信息服务费', label: '信息服务费' },
        { value: '服务费', label: '服务费' },
        { value: '广告发布费', label: '广告发布费' },
        { value: '信息技术服务费', label: '信息技术服务费' },
        { value: '视频制作费', label: '视频制作费' },
        { value: '软件开发服务费', label: '软件开发服务费' },
      ]
    },
    {
      value: '现代服务', label: '现代服务', children: [
        { value: '推广服务费', label: '推广服务费' },
        { value: '信息服务费', label: '信息服务费' },
        { value: '服务费', label: '服务费' },
        { value: '现代服务费', label: '现代服务费' },
        { value: '推广费', label: '推广费' },
        { value: '咨询服务费', label: '咨询服务费' },
        { value: '广告发布费', label: '广告发布费' },
      ]
    },
    {
      value: '广告服务', label: '广告服务', children: [
        { value: '广告发布费', label: '广告发布费' },
        { value: '广告费', label: '广告费' },
        { value: '广告发布服务', label: '广告发布服务'},
        { value: '广告服务费', label: '广告服务费'},
      ]
    },
    {
      value: '不动产', label: '不动产', children: [
        { value: '房屋租金', label: '房屋租金' },
      ]
    },
    { 
      value: '设计服务费', label: '设计服务费' 
    },
    {
      value: '信息系统增值服务', label: '信息系统增值服务', children: [
        { value: '技术服务费', label: '技术服务费' },
        { value: '广告费', label: '广告费' },
        { value: '信息服务费', label: '信息服务费' },
        { value: '服务费', label: '服务费' },
        { value: '广告发布费', label: '广告发布费' },
        { value: '信息技术服务费', label: '信息技术服务费' },
        { value: '视频制作费', label: '视频制作费' },
        { value: '软件开发服务费', label: '软件开发服务费' },
      ]
    },
    {
      value: '信息系统服务', label: '信息系统服务', children: [
        { value: '技术服务费', label: '技术服务费' },
        { value: '广告费', label: '广告费' },
        { value: '信息服务费', label: '信息服务费' },
        { value: '服务费', label: '服务费' },
        { value: '广告发布费', label: '广告发布费' },
        { value: '信息技术服务费', label: '信息技术服务费' },
        { value: '视频制作费', label: '视频制作费' },
        { value: '软件开发服务费', label: '软件开发服务费' },
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/commonData.js